import { success, error, loading } from 'State/actions';
import * as types from './types';

export const getCNVersionInformation = (setLoadingFlag) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      if (setLoadingFlag) {
        dispatch(
          loading(types.CN_VERSION_GET_VERSION_INFORMATION_LOADING, true)
        );
      }
      const response = await MPWWebApi.getGeneric(
        'ControlInfo/CNVersionInformation'
      );
      if (response) {
        dispatch(
          success(
            types.CN_VERSION_GET_VERSION_INFORMATION,
            response.data.Data.Data
          )
        );
      }
    } catch (ex) {
      dispatch(
        error(types.CN_VERSION_GET_VERSION_INFORMATION_ERROR, {
          title: 'Error',
          Message: 'Unable to get CN Version Information',
        })
      );
    } finally {
      if (setLoadingFlag) {
        dispatch(
          loading(types.CN_VERSION_GET_VERSION_INFORMATION_LOADING, false)
        );
      }
    }
  };
};

export const enqueueCNVersionUpdate = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.CN_VERSION_ENQUEUE_UPDATE_LOADING, true));
      const response = await MPWWebApi.postGenericInsertUpdate(
        'ControlInfo/UpdateCNVersion'
      );

      if (response) {
        dispatch(setUpdateEnqueuedSuccessfull(true));
        dispatch(setCNUpdateLoading(true));
      }
    } catch (ex) {
      dispatch(
        error(types.CN_VERSION_ENQUEUE_UPDATE_ERROR, {
          title: 'Error',
          Message: 'An Error Occured While Enqueuing The CN Version Update',
        })
      );
    } finally {
      dispatch(loading(types.CN_VERSION_ENQUEUE_UPDATE_LOADING, false));
    }
  };
};

export const enqueueCNPreview = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.CN_VERSION_ENQUEUE_PREVIEW_LOADING, true));
      const response = await MPWWebApi.getGeneric(
        'ControlInfo/GetCNVersionUpdatePreview'
      );

      if (response) {
        dispatch(setPreviewEnqueuedSuccessfull(true));
        dispatch(setCNPreviewLoading(true));
      }
    } catch (ex) {
      dispatch(
        error(types.CN_VERSION_ENQUEUE_UPDATE_ERROR, {
          title: 'Error',
          Message: 'An Error Occured While Enqueuing The CN Version Preview',
        })
      );
    } finally {
      dispatch(loading(types.CN_VERSION_ENQUEUE_PREVIEW_LOADING, false));
    }
  };
};

export const setPreviewEnqueuedSuccessfull = (successful) => {
  return {
    type: types.CN_VERSION_SET_PREVIEW_ENQUEUED_SUCCESSFUL,
    payload: successful,
  };
};

export const setUpdateEnqueuedSuccessfull = (successful) => {
  return {
    type: types.CN_VERSION_SET_ENQUEUED_SUCCESSFUL,
    payload: successful,
  };
};

export const setCNUpdateLoading = (loading) => {
  return {
    type: types.CN_VERSION_UPDATE_LOADING,
    payload: loading,
  };
};
export const setCNPreviewLoading = (loading) => {
  return {
    type: types.CN_VERSION_PREVIEW_LOADING,
    payload: loading,
  };
};



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/CNVersionInformation/actions.js